import { render, staticRenderFns } from "./MainLanding.vue?vue&type=template&id=5e3dd33e&"
import script from "./MainLanding.vue?vue&type=script&lang=js&"
export * from "./MainLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports